module.exports = __webpack_public_path__ + "static/media/close-notification.41e9c832.svg";